/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomainAdditionalPaymentData
 */
export interface ProjectDomainAdditionalPaymentData {
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    fullPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    domainsToPay?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    totalExtraPaidDomains?: number;
    /**
     * Net amount in minor currency units.
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    netAmount?: number;
    /**
     * VAT amount in minor currency units.
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    vatAmount?: number;
    /**
     * Rounding adjustment in minor currency units.
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    roundingAmount?: number;
    /**
     * Final amount in minor currency units.
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    totalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    currencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    vatPercentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    reverseCharge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDomainAdditionalPaymentData
     */
    isAdditionalPaymentNeeded?: boolean;
}

/**
 * Check if a given object implements the ProjectDomainAdditionalPaymentData interface.
 */
export function instanceOfProjectDomainAdditionalPaymentData(value: object): value is ProjectDomainAdditionalPaymentData {
    return true;
}

export function ProjectDomainAdditionalPaymentDataFromJSON(json: any): ProjectDomainAdditionalPaymentData {
    return ProjectDomainAdditionalPaymentDataFromJSONTyped(json, false);
}

export function ProjectDomainAdditionalPaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainAdditionalPaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'] == null ? undefined : json['price'],
        'fullPrice': json['fullPrice'] == null ? undefined : json['fullPrice'],
        'domainsToPay': json['domainsToPay'] == null ? undefined : json['domainsToPay'],
        'totalExtraPaidDomains': json['totalExtraPaidDomains'] == null ? undefined : json['totalExtraPaidDomains'],
        'netAmount': json['netAmount'] == null ? undefined : json['netAmount'],
        'vatAmount': json['vatAmount'] == null ? undefined : json['vatAmount'],
        'roundingAmount': json['roundingAmount'] == null ? undefined : json['roundingAmount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'vatPercentage': json['vatPercentage'] == null ? undefined : json['vatPercentage'],
        'reverseCharge': json['reverseCharge'] == null ? undefined : json['reverseCharge'],
        'isAdditionalPaymentNeeded': json['isAdditionalPaymentNeeded'] == null ? undefined : json['isAdditionalPaymentNeeded'],
    };
}

export function ProjectDomainAdditionalPaymentDataToJSON(json: any): ProjectDomainAdditionalPaymentData {
    return ProjectDomainAdditionalPaymentDataToJSONTyped(json, false);
}

export function ProjectDomainAdditionalPaymentDataToJSONTyped(value?: ProjectDomainAdditionalPaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'price': value['price'],
        'fullPrice': value['fullPrice'],
        'domainsToPay': value['domainsToPay'],
        'totalExtraPaidDomains': value['totalExtraPaidDomains'],
        'netAmount': value['netAmount'],
        'vatAmount': value['vatAmount'],
        'roundingAmount': value['roundingAmount'],
        'totalAmount': value['totalAmount'],
        'currencyCode': value['currencyCode'],
        'vatPercentage': value['vatPercentage'],
        'reverseCharge': value['reverseCharge'],
        'isAdditionalPaymentNeeded': value['isAdditionalPaymentNeeded'],
    };
}

